import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const requireComponent = require.context(
  `../public/static/json`,
  false,
  /.(json)$/
);

export default new Vuex.Store({
  state: {
    allTags: [],
    editing: undefined,
    nextFolio: undefined,
    record: null,
    policeReport: null,
    reportCatalogOptions: [],
    action: null,
    victims: [],
    policeReports: [],
    host: "https://admin-demo.datacivica.org/",
    reports: [],
    filteredReports: [],
    carousel: [],
    isLoading: false,
    showNotification: null,
    //showVictim: false,
    user: {
      email: null,
      permission: null,
    },
    userEdit: {
      email: "",
      role: "",
      name: "",
      profileImg: {},
      permission: {},
    },
    userList: [],
    currentToken: "",
    getUsersAsyncStatusCode: null,
    days: ["N/D"].concat([...Array(32).keys()].slice(1)).map(String),
    months: ["N/D"].concat([...Array(13).keys()].slice(1)).map(String),
    years: ["N/D"].concat(
      Array.from(
        {
          length: new Date().getFullYear() - 1949,
        },
        (_, i) => 1950 + i
      )
        .reverse()
        .map(String)
    ),
    directAnswers: [
      { name: "Si", slug: "yes" },
      { name: "No", slug: "no" },
    ],
    indirectAnswers: [
      {
        name: "Si",
        slug: "yes",
      },
      {
        name: "No",
        slug: "no",
      },
      {
        name: "N/D",
        slug: "uncertain",
      },
    ],
    sexes: [
      {
        name: "Hombre",
        slug: "man",
      },
      {
        name: "Mujer",
        slug: "woman",
      },
    ],
    medicalServiceProviders: [
      {
        name: "IMSS",
        slug: "imss",
      },
      {
        name: "Seguro popular",
        slug: "popularInsurance",
      },
      {
        name: "ISSSTE",
        slug: "issste",
      },
      {
        name: "PENSIONES",
        slug: "pension",
      },
      {
        name: "Otro",
        slug: "other",
      },
    ],
    educationLevels: [
      {
        name: "Ninguno ",
        slug: "none",
      },
      {
        name: "Primaria ",
        slug: "elementary",
      },
      {
        name: "Secundaria",
        slug: "juniorHighSchool",
      },
      {
        name: "Preparatoria",
        slug: "highSchool",
      },
      {
        name: "Licenciatura",
        slug: "bachelor",
      },
      {
        name: "Posgrado",
        slug: "doctorate",
      },
    ],
  },
  getters: {
    record: (state) => state.record,
    victims: (state) => state.victims,
    reports: (state) => state.reports,
    filteredReports: (state) => state.filteredReports,
    userList: (state) => state.userList,
    userEdit: (state) => state.userEdit,
    findVictim: (state) => (mod) => {
      let modVictim = state.victims.find((d) => d.victimFolio === mod.folio);
      modVictim[mod.prop] = mod.val;

      return modVictim;
    },
    user: (state) => state.user,
  },
  mutations: {
    setIsLoadingState(state, isLoading) {
      state.isLoading = isLoading;
    },
    setShowNotification(state, isEnabled) {
      state.showNotification = isEnabled;
    },
    setUserEdit(state, userInfo) {
      state.userEdit = userInfo;
      state.userEdit.id = userInfo["_id"];
    },
    // Attention
    updateAdvisoryNumber(state, number) {
      state.record.attention.advisoryNumber = number;
    },
    updateAttentionRelation(state, related) {
      state.record.attention.isRelated = related;
    },
    updateRelatedAdvisory(state, relation) {
      state.record.relatedAdvisory = relation;
    },
  },
  actions: {
    setUser({ state }, user) {
      state.user = user;
    },
    getUser({ state }) {
      return axios.post(state.host + "api/v1/getSessionUser", {
        user: state.user,
      });
    },
    setRecord({ state }, record) {
      state.record = record;
      //state.victims = record.victims;
    },
    updateVictims({ state }, info) {
      if (info.operation === "add") {
        state.victims.push({
          victimFolio: info.currentFolio + 1,
          victimName: "",
          postal: {
            url: "",
            fecha: "",
            etag: "",
          },
          photo: "",
          disappearancePlace: "",
          municipality: "",
          age: "",
          lastSeenDate: null,
          status: "",
          physicalDescription: "",
        });
      } else {
        state.victims = state.victims.filter(
          (item) => item.victimFolio !== info.currentFolio
        );

        state.victims.forEach((victim, key) => {
          Vue.set(victim, "victimFolio", key + 1);
        });
        state.victims = state.victims;
      }
    },
    updateVictimInfo({ state }, newInfo) {
      state.victims = [
        ...state.victims.filter(
          (element) => element.victimFolio !== newInfo.folio
        ),
        this.getters.findVictim(newInfo),
      ];
    },
    getAllReports({ state }) {
      return axios
        .post(state.host + "api/v1/allReports", {
          user: state.user,
        })
        .then((response) => {
          state.reports = response.data.result;
          state.filteredReports = state.reports;
          state.nextFolio = Number(response.data.folio) + 1;
        })
        .catch(() => {
          state.reports = [];
          state.filteredReports = [];
          state.nextFolio = 0;
        });
    },
    async getSingleReport({ state, commit }, reportId) {
      try {
        return axios.post(state.host + "api/v1/singleReport", {
          reportId: reportId,
          user: state.user,
        });
      } catch {
        commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: "Error al validar al usuario, intente de nuevo",
        });
      }
    },
    createCatalogOption({ state }, data) {
      try {
        return axios.post(state.host + "api/v1/reportscatalog", {
          name: data.name,
          field: data.field,
          fixed: "false",
          user: state.user,
        });
      } catch (error) {
        console.log(error, "error");
      }
    },
    async getCatalogOptions({ state }) {
      try {
        const response = await axios.post(
          state.host + "api/v1/reportscatalog/all",
          {
            user: state.user,
          }
        );
        state.reportCatalogOptions = response.data;
      } catch (error) {
        console.log(error, "error");
      }
    },
    updateCatalogOption({ state }, item) {
      try {
        return axios.put(state.host + "api/v1/reportscatalog", {
          _id: item._id,
          field: item.field,
          name: item.name,
          user: state.user,
        });
      } catch (error) {
        console.log(error, "error");
      }
    },
    async deleteCatalogOption({ state }, item) {
      try {
        // console.log(item, "IDs")
        return axios.post(state.host + "api/v1/deleteReportscatalog", {
          _id: item._id,
          field: item.field,
          name: item.slug,
          user: state.user,
        });
      } catch (error) {
        console.log(error, "error");
      }
    },
    async createReport({ state }) {
      state.record.updates.push({
        when: new Date(),
        who: state.user.email,
        changes: "Registro inicial",
        comments: "Registro inicial",
      });
      return axios.post(state.host + "api/v1/reports", {
        record: state.record,
        user: state.user,
      });
    },
    async updateReport({ state }) {
      try {
        state.record.updates.push({
          when: new Date(),
          who: state.user.email,
          changes:
            state.record["edit_reason"] === "update"
              ? "Actualización del caso"
              : "Corrección de errores",
          comments: state.record["edit_comments"],
        });
        return axios.put(state.host + "api/v1/reports", {
          record: state.record,
          user: state.user,
        });
      } catch (err) {
        return err;
      }
    },
    async deleteReport({ state }) {
      try {
        return axios.post(state.host + "api/v1/deleteReports", {
          params: {
            reportId: state.record._id,
            user: state.user,
          },
        });
      } catch (err) {
        return err;
      }
    },
    async createUser({ state }) {
      state.userEdit.user = state.user;
      return axios.post(state.host + "api/v1/register", state.userEdit);
    },
    async getTags({ state }) {
      return axios.post(state.host + "api/v1/getTags", {
        user: state.user,
      });
    },
    async createTags({ state }, field) {
      return axios.post(state.host + "api/v1/tags", {
        tag: field,
        user: state.user,
      });
    },
    async updateTag({ state }, field) {
      return axios.put(state.host + "api/v1/tags", {
        tag: field,
        user: state.user,
      });
    },
    async deleteTag({ state }, field) {
      return axios.post(state.host + "api/v1/deleteTags", {
        params: {
          tagId: field,
          user: state.user,
        },
      });
    },
    async updateUser({ state }, field) {
      try {
        return axios.put(state.host + "api/v1/updateUser", {
          features: {
            id: state.userEdit.id,
            field,
            content: state.userEdit[field],
          },
          user: state.user,
        });
      } catch (err) {
        return err;
      }
    },
    async updatePassword({ state }) {
      return axios.put(state.host + "api/v1/updatePassword", {
        features: state.userEdit,
        user: state.user,
      });
    },
    async deleteUser({ state }) {
      state.deleteUsersAsyncPending = true;
      return axios.post(state.host + "api/v1/deleteUser", {
        params: {
          id: state.userEdit._id,
          user: state.user,
        },
      });
    },
    async getUserList({ state }) {
      return axios
        .post(state.host + "api/v1/getUserList", {
          params: {},
          user: state.user,
        })
        .then((response) => {
          state.getUsersAsyncStatusCode = response.status;
          state.userList = response.data.result;
        })
        .catch((error) => {
          state.getUsersAsyncStatusCode = {
            pending: false,
            statusCode: error.status,
          };
        });
    },
    uploadImage({ state }, imageData) {
      imageData.user = state.user;
      return axios.post(state.host + "api/v1/images", imageData);
    },
    uploadFile({ state }, fileData) {
      fileData.user = state.user;
      return axios.post(state.host + "api/v1/files", fileData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    deleteFile({ state }, params) {
      return axios.post(state.host + "api/v1/deletefile", {
        data: params,
        user: state.user,
      });
    },
    updateCsv({ state }) {
      return axios.post(state.host + "api/v1/generateCsv", {
        user: state.user,
      });
    },
    async login({ state }, userData) {
      return axios.post(
        state.host + "api/v1/login",
        {
          email: userData.email,
          password: userData.password,
        } /*, {
        withCredentials: true
      }*/
      );
    },
    async logout({ state }) {
      return axios.get(state.host + "api/v1/logout", {
        withCredentials: false,
      });
    },
    addToken({ state }) {
      return axios.post(state.host + "api/v1/token", {
        email: state.user.email,
        role: state.user.role,
        token: state.currentToken,
      });
    },
    sendPushNotification({ state }, notification) {
      return axios.post(state.host + "api/v1/notification", {
        notification: notification,
        user: state.user,
      });
    },
    async initAllForms({ state }) {
      console.log("start init all forms");
      return new Promise((resolve) => {
        requireComponent.keys().forEach(async (fileName, i) => {
          let axiosFile = fileName.replace(/^.\//, "");
          let jsonResponse = await axios.get(
            `${window.location.origin}/static/json/${axiosFile}`
          );
          let stateVariable = axiosFile.replace(/\.\w+$/, "");
          state[stateVariable] = jsonResponse.data;
          if (i === requireComponent.keys().length - 1) {
            return resolve("ok");
          }
        });
      });
    },
  },
});
